export default __webpack_public_path__ + "static/media/mms.df372d5c.png";